import { replace, trim, lowerCase } from 'lodash'

const sanitizeNameForTag = (string) => {
  return replace(trim(lowerCase(string)), new RegExp(' ', 'g'), '-')
}

export { sanitizeNameForTag }
